import { Map as IMap } from 'immutable';
import * as TYPE from '../../js/actions/assets';

export const initialState = IMap({
    home: {},
});

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case TYPE.SAVE_HERO_IMAGE:
            return state.merge(IMap({
                home: action.payload,
            }));
        default:
            return state;
    }
}
